import { FC, useState } from "react";
import { useNavigate } from "react-router-dom";

import { Alert, Button, Form, Input } from "antd";
import Title from "antd/lib/typography/Title";

import styles from "./LoginPage.module.scss";

import { AuthApi } from "@/api";
import { clearAuthToken, saveAuthToken } from "@/utils/tokenHelpers";
import { ERROR_500_MESSAGE } from "@/api/constants";
import { setUserType } from "@/store/reducers/user/userSlice";
import { useAppDispatch } from "@/hooks/redux";

const LoginPage: FC = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const onFinish = (values: any) => {
    (async () => {
      try {
        setLoading(true);
        const { token, userType } = await AuthApi.login({
          login: values.login,
          password: values.password,
        });
        saveAuthToken(token);
        dispatch(setUserType(userType));
        navigate("/");
      } catch (e: any) {
        clearAuthToken();
        if (e.response?.data?.message) {
          setError(e.response?.data?.message);
        } else {
          setError(ERROR_500_MESSAGE);
        }
      } finally {
        setLoading(false);
      }
    })();
  };

  return (
    <Form data-testid="login-page" name="login" className={styles.form} onFinish={onFinish}>
      <Title level={4} className={styles.title}>
        Authorize
      </Title>
      <Form.Item
        label="Login"
        name="login"
        rules={[{ required: true, message: "Please input the login" }]}
      >
        <Input />
      </Form.Item>

      <Form.Item
        label="Password"
        name="password"
        rules={[{ required: true, message: "Please input the password" }]}
      >
        <Input.Password />
      </Form.Item>

      {!!error && (
        <Alert className={styles.errorMessage} message={error} type="error" />
      )}

      <Form.Item>
        <Button
          disabled={loading}
          loading={loading}
          className={styles.submit}
          type="primary"
          htmlType="submit"
        >
          Login
        </Button>
      </Form.Item>
    </Form>
  );
};

export default LoginPage;
